import { textblockTypeInputRule } from '@tiptap/core';
import CodeBlock from '@tiptap/extension-code-block';

// Upstream's fence rules only fire on a trailing space or Enter, and in a chat
// composer Enter sends the message — so ``` never got the chance to convert.
// Fire on the closing backtick instead: a paragraph holding nothing but a fence
// isn't text anyone means to send. Backspace undoes it like any input rule.
const fenceInputRegex = /^(?:```|~~~)$/;

const CustomCodeBlock = CodeBlock.extend({
  addInputRules() {
    return [
      textblockTypeInputRule({
        find: fenceInputRegex,
        type: this.type,
      }),
    ];
  },
});

export default CustomCodeBlock;
